import {Fragment} from "react";
import {HOME_SECTION_KEYS} from "./homeSectionKeys";
import {isFooterSectionKey, renderHomeSection} from "./renderHomeSection";
import {shouldShowHomeSection} from "./shouldShowHomeSection";

const getSectionZone = sectionKey => {
  if (isFooterSectionKey(sectionKey)) return "footer";
  if (
    sectionKey === HOME_SECTION_KEYS.THEMES_CAROUSEL ||
    sectionKey === HOME_SECTION_KEYS.HOME_NEWS_CAROUSEL
  ) {
    return "themes";
  }
  if (
    sectionKey === HOME_SECTION_KEYS.CUSTOM_CAROUSELS_GROUP ||
    sectionKey === HOME_SECTION_KEYS.RECENT_GAMES
  ) {
    return "mid";
  }
  return "hero";
};

/**
 * @param {string} zone
 * @param {import("./homeLayoutContext").HomeSection[]} batch
 * @param {import("./homeLayoutContext").HomeLayoutContext} ctx
 */
const renderZone = (zone, batch, ctx) => {
  const children = batch
    .map(section => {
      const node = renderHomeSection(section.section_key, ctx);
      if (node == null) return null;
      return <Fragment key={section.id}>{node}</Fragment>;
    })
    .filter(Boolean);

  if (children.length === 0) return null;

  if (zone === "hero") {
    return <div className={ctx.styles.heroArea}>{children}</div>;
  }

  if (zone === "mid") {
    return (
      <div className={ctx.styles.heroArea}>
        <div className={ctx.styles.sectionBlockAlt}>{children}</div>
      </div>
    );
  }

  if (zone === "themes") {
    return <div style={{position: "relative"}}>{children}</div>;
  }

  if (zone === "footer") {
    return (
      <div
        className={ctx.styles.homeSections}
        ref={ctx.sectionsRef}
      >
        {children}
      </div>
    );
  }

  return <>{children}</>;
};

/**
 * @param {{
 *   sections: import("./homeLayoutContext").HomeSection[],
 *   ctx: import("./homeLayoutContext").HomeLayoutContext,
 * }} props
 */
const DynamicHomeLayout = ({sections, ctx}) => {
  const visibilityCtx = {
    authStatus: ctx.authStatus,
    isHomeSearching: Boolean(ctx.isHomeSearching),
  };

  const visibleSections = sections.filter(section => shouldShowHomeSection(section, visibilityCtx));

  const zoneNodes = [];
  let batch = [];
  let currentZone = null;

  const flushBatch = () => {
    if (!batch.length) return;
    const node = renderZone(currentZone, batch, ctx);
    if (node) zoneNodes.push(<Fragment key={`zone-${batch[0].id}`}>{node}</Fragment>);
    batch = [];
    currentZone = null;
  };

  for (const section of visibleSections) {
    const zone = getSectionZone(section.section_key);
    if (currentZone !== null && zone !== currentZone) {
      flushBatch();
    }
    currentZone = zone;
    batch.push(section);
  }

  flushBatch();

  return <>{zoneNodes}</>;
};

export default DynamicHomeLayout;
